import React, { Component } from "react";
import PropTypes from 'prop-types';
// @material-ui/core components
import { withStyles } from "@material-ui/styles";
import Modal from "@material-ui/core/Modal";
import DialogContent from '@material-ui/core/DialogContent';
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "components/Table/Table.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";
// services
import audioService from "services/audio.service";
import unityService from "services/unity.service";
// management imports
import CadastrarAudios from "./Cadastrar";
import EditarAudios from "./Editar";
// import EditarAudios from "./Editar";
import DeletarAudios from "./Deletar";

const styles = theme => ({
 	cardCategoryWhite: {
		"&,& a,& a:hover,& a:focus": {
			color: "rgba(255,255,255,.62)",
			margin: "0",
			fontSize: "14px",
			marginTop: "0",
			marginBottom: "0"
		},
		"& a,& a:hover,& a:focus": {
			color: "#FFFFFF"
		}
  	},
	cardTitleWhite: {
		color: "#FFFFFF",
		marginTop: "0px",
		minHeight: "auto",
		fontWeight: "300",
		fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
		marginBottom: "3px",
		textDecoration: "none",
		"& small": {
			color: "#777",
			fontSize: "65%",
			fontWeight: "400",
			lineHeight: "1"
		}
	}
});

class GerenciarAudios extends Component {
    constructor(props) {
        super(props);
		this.state = {audios: [], show: "", editUid: "", units: []};
		this.handleSearch();

        // this.handleChange = this.handleChange.bind(this);
        // this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleOpenCreate = () => {
      	this.setState({ show: "create" });
	};

	handleOpenEdit = (audio) => {
		this.setState({ show: "edit", editUid: audio });
	};
	  
	handleOpenDelete = (uid) => {
		this.setState({ show: "delete", editUid: uid });
  	};
	
	async handleSearch() {
		audioService.listAllAudios().then(audios => {
			const tableAudios = []
		   	audios.forEach(audio => {
				tableAudios.push([
						audio.key, 
						audio.title, 
						audio.unity,
						<Button color="primary" round onClick={(event) => {this.handleOpenEdit(audio)}}>Editar</Button>,
						<Button color="primary" round onClick={(event) => {this.handleOpenDelete(audio.key)}}>Excluir</Button>
				])
			})
			this.setState({audios: tableAudios})
	  	})

		unityService.listAllUnits().then(units => {
			const tableUnits = [];
			units.forEach(unity => tableUnits.push({key: unity.key, value: unity.key, label: `${unity.key} - ${unity.title}`}));
			this.setState({units: tableUnits})
		})
	}

    render() {
        const { classes } = this.props;
        return (
          	<GridContainer>
				<GridItem xs={12} sm={12} md={12}>
					<Button color="primary" type="submit" round onClick={this.handleOpenCreate}>Cadastrar Audio</Button>
				</GridItem>
            	<GridItem xs={12} sm={12} md={12}>
              		<Card>
						<CardHeader color="primary">
							<h4 className={classes.cardTitleWhite}>Lista de Audios</h4>
							<p className={classes.cardCategoryWhite}>
								Lista para visualização e gerenciamento dos Audios Extras
							</p>
						</CardHeader>
                		<CardBody>
							<Table
								tableHeaderColor="primary"
								tableHead={["ID do Audio", "Título do Audio", "ID da Unidade", "Editar", "Excluir"]}
								tableData={this.state.audios}
							/>
                		</CardBody>
              		</Card>
            	</GridItem>
				<Modal open={this.state.show === 'create'} onClose={() => {this.setState({show: ""}); this.handleSearch()}} aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description">
					<DialogContent>
						<CadastrarAudios units={this.state.units} onClose={() => {this.setState({show: ""}); this.handleSearch()}} />
					</DialogContent>
				</Modal>
				<Modal open={this.state.show === 'edit'} onClose={() => {this.setState({show: ""}); this.handleSearch()}} aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description">
					<DialogContent>
						<EditarAudios audio={this.state.editUid} units={this.state.units} onClose={() => {this.setState({show: ""}); this.handleSearch()}} />
					</DialogContent>
				</Modal>
				<Modal open={this.state.show === 'delete'} onClose={() => {this.setState({show: ""}); this.handleSearch()}} aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description">
					<DialogContent>
						<DeletarAudios uid={this.state.editUid} onClose={() => {this.setState({show: ""}); this.handleSearch()}} />
					</DialogContent>
				</Modal>
          	</GridContainer>
        );
    };
}

GerenciarAudios.propTypes = {
    classes: PropTypes.object.isRequired,
};
  
export default withStyles(styles)(GerenciarAudios);